import * as React from 'react';
import classNames from 'classnames';
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons/faChevronLeft';
import { faTimes } from '@fortawesome/pro-light-svg-icons/faTimes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import isEqual from 'react-fast-compare';
import styles from './ModalHeader.module.scss';

type Props = {
    backButton?: boolean;
    className: string;
    closeButton: boolean;
    content: React.ReactNode;
    contentClassName: string;
    hideLogo: boolean;
    logoClassName: string;
    onBack?: (event: any) => void;
    onHide: (event: any) => void;
};

export default class ModalHeader extends React.Component<Props> {
    static defaultProps = {
        backButton: false,
        className: '',
        closeButton: true,
        content: '',
        contentClassName: '',
        hideLogo: false,
        logoClassName: '',
    };

    shouldComponentUpdate = (nextProps: Props) => !isEqual(this.props, nextProps);

    render() {
        const {
            backButton,
            className,
            closeButton,
            content,
            contentClassName,
            hideLogo,
            logoClassName,
            onBack,
            onHide,
        } = this.props;

        const headerClass = classNames(className, styles.header);
        const logoClass = classNames(logoClassName, styles.logo);
        const contentClass = classNames(contentClassName, styles.content);

        return (
            <div className={headerClass}>
                {backButton && (
                    <button className={styles['back-button']} onClick={onBack} type="submit">
                        <FontAwesomeIcon icon={faChevronLeft} />
                    </button>
                )}
                {closeButton && (
                    // @ts-ignore
                    <button className={styles['close-button']} onClick={onHide} testid="closeButton" type="submit">
                        <FontAwesomeIcon className={styles.closeButton} icon={faTimes} size="3x" />
                    </button>
                )}
                {!hideLogo && (
                    <img alt="logo" className={logoClass} src="https://p1.liveauctioneers.com/dist/images/logo.svg" />
                )}
                {content && <span className={contentClass}>{content}</span>}
            </div>
        );
    }
}
